export default {
  token: null,
  refreshToken: null,
  init: false,
  roles: ['guest'],
  storage: 'ap_bearer_token',
  refreshStorage: 'ap_bearer_refresh_token',
  registrationToken: null,
  registrationStorage: 'registration_bearer_token',
  registrationStorageStep: 'registration_step',
  registrationStep: 1
}



// WEBPACK FOOTER //
// ./src/store/auth/state.js